export default __webpack_public_path__ + "static/media/Audiophile - Preview 1.48f21a2d.png";